// Runtime system flags. Cloudflare Pages builds read these from Vite environment
// variables; omitting the variable keeps the live-demo safety default.
export const COA_IMPORT_AI_ANALYSIS_DISABLED =
  import.meta.env.VITE_COA_IMPORT_AI_ANALYSIS_DISABLED !== 'false';
